import { render, staticRenderFns } from "./PremiumModal.vue?vue&type=template&id=032086ee&"
import script from "./PremiumModal.vue?vue&type=script&lang=js&"
export * from "./PremiumModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports